import { getPreviewRecipientValue } from '../../../utils/email'

export function getNextFiles({ fileId, files, templateFile }) {
  return files.map(file =>
    file.template === templateFile.template ? { ...file, id: fileId } : file
  )
}

export function getGeneratedTemplatePdf({ file, generatedPdfIds, recipient }) {
  return generatedPdfIds.find(
    generatedPdf =>
      generatedPdf.template === file.template &&
      generatedPdf.recipient === recipient.value
  )
}

export function getPrevRecipientIndex(recipientIndex) {
  return recipientIndex > 1 ? recipientIndex - 1 : 1
}

export function getSelectedRecipient(recipient) {
  return {
    label: recipient,
    value: recipient.value,
  }
}

export function getPreviewTextParams({
  currentRecipient,
  getPreviewDependencies,
  recipients,
  subject,
  templateEntityApiParams,
  text,
}) {
  const recipient = recipients[currentRecipient - 1]

  const dependencyValues = {
    ...templateEntityApiParams,
    ...getPreviewDependencies?.(recipient),
    recipient_id: getPreviewRecipientValue(recipient),
  }

  return {
    ...dependencyValues,
    dependencies: Object.keys(dependencyValues),
    subject,
    text,
  }
}

export function filterByFullNameAndEmail({ email, fullname }, search) {
  if (!search) {
    return true
  }

  const searchValueLowerCase = search.toLowerCase()

  return (
    email?.toLowerCase().includes(searchValueLowerCase) ||
    fullname?.toLowerCase().includes(searchValueLowerCase)
  )
}
